import Image from 'next/image';

import GGLogo from '../../../../public/assets/logos/G_Gradient.svg';

import s from './ClassicFooter.module.css';

export const ClassicFooter = () => (
  <footer className={s.footer}>
    <div className={s.desktopLogo}>
      <a href="https://glossgenius.com">
        <span className={s.poweredByLabel}>powered by</span>
        <Image
          src="/assets/logos/GG_Logo_White.svg"
          width="163"
          height="17"
          alt="GlossGenius"
        />
      </a>
    </div>

    <div className={s.mobileLogo}>
      <a href="https://glossgenius.com" title="Go to GlossGenius">
        <GGLogo width="26" height="16" />
      </a>
    </div>
  </footer>
);
